import { getActiveBuildings } from "./index24.js";
import { createPodiumGlazing } from "@project-rouge/rg-three";
const pipeAddPodiumGlazing = ([parent, { buildingIds, aggProps }]) => {
	const buildings = getActiveBuildings(parent, aggProps);
	for (const building of buildings) {
		if (buildingIds && !buildingIds.includes(building.uuid)) continue;
		createPodiumGlazing(building);
	}
	return [parent, void 0];
};
export { pipeAddPodiumGlazing };

//# sourceMappingURL=index85.js.map